import apiRequest from "../services/apiRequest";
import { useEffect, useState, useContext } from "react";
import { NotificationsContext } from "../ui-components/Notifications";


export const useSalesAndFields = () => {

  const [sales, setSales] = useState();
  const [fields, setFields] = useState();
  const { push } = useContext(NotificationsContext);

  const fetchSalesAndFields = async () => {
    let fetchInternalUsers = apiRequest.get("/users/internal");

    Promise.all([fetchInternalUsers])
      .then((res) => {
        setSales(
          (res[0] || [])
            .filter((u) => u.role.name === "agent" && u.id_salesforce)
            .sort((a, b) => a.lastname.localeCompare(b.lastname))
            .reduce(
              (obj, i) =>
                _.set(obj, [i.id_salesforce], `${i.lastname} ${i.firstname}`.toUpperCase()),
              {}
            )
        );
        setFields(
          (res[0] || [])
            .filter((u) => u.role.name === "field" && u.id_salesforce)
            .sort((a, b) => a.lastname.localeCompare(b.lastname))
            .reduce(
              (obj, i) =>
                _.set(obj, [i.id_salesforce], `${i.lastname} ${i.firstname}`.toUpperCase()),
              {}
            )
        );
      })
      .catch(() => {
        push({
          title: "server_error",
          type: "error",
        });
      });
  }
  useEffect(() => {
    fetchSalesAndFields().then(() => {
        console.log("Sales and Fields fetched");
        setSales(sales);
        setFields(fields);
      }
    )
  }, []);

  return {
    sales,
    fields,
  }
}